import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getPageTitleForPath } from '../utils/pageTitles'

/** Push SPA route changes to GTM dataLayer (container installed in index.html). */
export function useGtmPageView(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    const dataLayer = (window.dataLayer = window.dataLayer ?? [])
    const pageTitle = getPageTitleForPath(pathname)
    dataLayer.push({
      event: 'page_view',
      page_path: pathname,
      ...(pageTitle ? { page_title: pageTitle } : {}),
    })
  }, [pathname])
}
